import { Avatar } from 'primereact/avatar';
import { Card } from 'primereact/card';
import { ReactNode } from 'react';

interface ChatMessageProps {
  name: string;
  createdAt: string;
  isSender: boolean;
  children: ReactNode;
}

export const ChatMessage = ({
  name,
  createdAt,
  isSender,
  children,
}: ChatMessageProps) => {
  return (
    <Card
      className="border-round-xl shadow-none"
      style={{
        border: '1px solid lightgrey',
        backgroundColor: isSender ? 'var(--bq-color-white)' : '',
      }}
      pt={{
        body: { className: 'p-3' },
        content: { className: 'p-0' },
      }}
    >
      <div className="flex gap-2">
        <div className="flex flex-column">
          <Avatar
            label={isSender ? name.split('')[0] : 'B'}
            style={{
              backgroundColor: '#175eef',
              color: '#ffffff',
            }}
            shape="circle"
          />
        </div>
        <div className="flex flex-column justify-content-between">
          <div className="flex flex-row h-2rem align-items-center gap-2">
            <div>{name}</div>
            <div
              style={{ width: '1px', height: '1.2rem' }}
              className="bg-gray-300"
            ></div>
            <div>{createdAt}</div>
          </div>
          <div>{children}</div>
        </div>
      </div>
    </Card>
  );
};
